var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BjDrawerForm",
        {
          ref: "BjDrawerForm",
          attrs: {
            form: _vm.form,
            rules: _vm.rules,
            "label-width": "130px",
            width: "1100px",
          },
          on: { handleConfirm: _vm.handleConfirm },
        },
        [
          [
            _c(
              "BjDivider",
              [
                _vm._v(_vm._s(_vm.$t("goodsPage.package.Info")) + " "),
                _c(
                  "template",
                  { slot: "right" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.addPackage },
                      },
                      [_vm._v(_vm._s(_vm.$t("addText")))]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
            _c(
              "el-table",
              {
                attrs: { data: _vm.form.PackageVOList, border: "", script: "" },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: _vm.$t("table.countText"),
                    width: "60",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "packingMethod",
                    label: _vm.$t("goodsPage.package.Method"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                _vm.PACKAGE_TYPE_LIST.bjGet(
                                  scope.row.packingMethod
                                )
                              )
                            )
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "name",
                    label: _vm.$t("goodsPage.package.Name"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "sku",
                    label: _vm.$t("goodsPage.package.SKU"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "qty",
                    label: _vm.$t("goodsPage.package.num"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "materialFee",
                    label: _vm.$t("goodsPage.package.money1"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(_vm._s(scope.row.materialFee))]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "labourFee",
                    label: _vm.$t("goodsPage.package.money2"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(_vm._s(scope.row.labourFee))]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("table.operationText"),
                    align: "center",
                    width: "100",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        var $index = ref.$index
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.onDelete(row, $index)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("delText")))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _c(
        "BjDialog",
        {
          attrs: {
            title: _vm.$t("goodsPage.package.Info"),
            visible: _vm.packageVisible,
            width: "400px",
          },
          on: {
            close: function ($event) {
              return _vm.clearVisible()
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "packageForm",
              attrs: {
                model: _vm.packageForm,
                rules: _vm.rules,
                "label-width": "100px",
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("goodsPage.package.SKU"),
                    prop: "packageName",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": _vm.packageList,
                      placeholder: _vm.$t("goodsPage.package.Name"),
                    },
                    on: { change: _vm.logPackage },
                    model: {
                      value: _vm.packageForm.packageName,
                      callback: function ($$v) {
                        _vm.$set(_vm.packageForm, "packageName", $$v)
                      },
                      expression: "packageForm.packageName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("goodsPage.package.num"),
                    prop: "qty",
                  },
                },
                [
                  _c("BjInputNumber", {
                    attrs: { placeholder: _vm.$t("goodsPage.package.num") },
                    model: {
                      value: _vm.packageForm.qty,
                      callback: function ($$v) {
                        _vm.$set(_vm.packageForm, "qty", $$v)
                      },
                      expression: "packageForm.qty",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.clearVisible()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmPackage },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }